import React from 'react';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import ToMainMenuButton from '@ts-core/components/ToMainMenuButton';
import { TabPagesHookOutput } from '@ts-core/core/hooks/ui';

import RankingsPageHeader from '../../components/RankingsPageHeader';

export interface RankingsPageProps {
  tabsProps: TabPagesHookOutput;
}

const RankingsPage = (props: RankingsPageProps) => {
  const intl = useIntl();
  const { tabsProps } = props;
  const { onGoToTab, tabs, activePage } = tabsProps;

  return (
    <Box>
      <ToMainMenuButton title={intl.formatMessage({ id: 'quickLink.rankings' })} />
      <RankingsPageHeader tabs={tabs} onGoToTab={onGoToTab} activeTab={activePage?.tab} />
      {activePage?.page && <Box mt={1}>{activePage.page}</Box>}
    </Box>
  );
};

export default RankingsPage;
